import { ESCALA, formatarValor } from "../tema";
import { estiloRotulo, montarSeries, opcoesBase } from "./base";

/**
 * Família 7 — barras por ano com seta de variação.
 *
 * É o formato dos "Indicadores" (Boi Gordo, Boi Magro, Soja Brasil): uma
 * barra por ano, o valor na ponta, e ao lado uma seta grande verde ou
 * vermelha com a variação do período — mais um selo de % sobreposto às
 * barras comparadas.
 *
 * A barra é um gráfico de verdade (os valores escalam com os dados); a
 * seta e o selo são desenho, feitos em chart.events.render via comExtras.
 */
const modelo = {
  id: "barras-seta",
  label: "Barras com seta de variação",
  descricao: "Uma barra por ano mais a seta de variação do período. Ex.: Indicador Boi Gordo.",

  build(spec) {
    const base = opcoesBase(spec);
    const opcoesValor = spec.valores || {};
    // A faixa da esquerda precisa caber a seta E os rótulos de ano, que
    // nas referências ficam fora das barras. Sem essa folga o desenho é
    // cortado pela borda da imagem.
    const espacoSeta = (spec.extras?.seta ? 112 : 26) * ESCALA;

    const opcoes = {
      ...base,
      chart: {
        ...base.chart,
        type: "bar",
        marginLeft: espacoSeta,
        marginRight: 14 * ESCALA,
        marginBottom: (spec.extras?.rodape ? 14 : 6) * ESCALA,
      },
      xAxis: {
        ...base.xAxis,
        categories: spec.dados?.categorias || [],
        reversed: true,
        lineWidth: 0,
        labels: {
          ...base.xAxis.labels,
          // Ano fora da barra, encostado nela pela direita.
          align: "right",
          x: -5 * ESCALA,
          style: {
            ...base.xAxis.labels.style,
            textOverflow: "none",
          },
        },
      },
      yAxis: { ...base.yAxis, maxPadding: 0.14 },
      plotOptions: {
        ...base.plotOptions,
        bar: {
          borderWidth: 0,
          pointPadding: 0.04,
          groupPadding: 0.06,
          dataLabels: {
            ...estiloRotulo(spec),
            align: "left",
            inside: false,
            x: 3 * ESCALA,
            formatter() {
              return formatarValor(this.y, opcoesValor);
            },
          },
        },
      },
      series: montarSeries(spec, { showInLegend: false }),
    };

    return opcoes;
  },

  exemplo() {
    return {
      modelo: "barras-seta",
      titulo: [
        { texto: "Indicador Boi Magro GO", cor: "#F0F000" },
        { texto: " - Rural Business", cor: "#FFFFFF" },
      ],
      subtitulo: [{ texto: "Em 3 de Setembro (R$/cab)", cor: "#FFFFFF" }],
      fonte: "Fonte: IPAR RURAL BUSINESS",
      fundo: "#000000",
      fundoPlot: "nenhum",
      dados: {
        categorias: ["2026", "2025", "2024", "2023", "2022"],
        series: [
          {
            nome: "Valor",
            cor: "#FFFF0B",
            corFim: "#7D8015",
            valores: [4900, 4100, 3000, 2900, 3600],
          },
        ],
      },
      legenda: { visivel: false },
      valores: { decimais: 0, prefixo: "", sufixo: "", exibirEm: "todos" },
      rotulo: { corTexto: "#000000", corFundo: "#FFFFFF", corBorda: "#000000" },
      extras: {
        formato: "chato",
        seta: {
          // Sem `texto` fixo: o percentual, o sentido e a cor saem do
          // calculo abaixo. Trocar os numeros atualiza a seta sozinha.
          // de: -1 (ultima categoria) ate para: 0 (primeira) = variacao do
          // periodo, ja que as referencias listam do ano mais recente para
          // o mais antigo.
          calculo: { serie: 0, de: -1, para: 0 },
          // O percentual vai na caixa abaixo da seta; a seta so aponta e se
          // colore. Posicao e tamanho das duas saem do espaco livre na
          // margem (ver desenharIndicadorVariacao).
          mostrarTexto: false,
          caixa: {
            calculo: { serie: 0, de: -1, para: 0 },
            corFundoFixa: "#FFFFFF",
            corTexto: "#000000",
            // borda acompanha a cor da variacao (verde na alta, vermelha
            // na queda), como a seta
            bordaDaVariacao: true,
            larguraBorda: 2,
            tamanho: 11,
          },
        },
        caixas: [
          {
            // Variacao do ultimo ano contra o anterior.
            calculo: { serie: 0, de: 1, para: 0 },
            em: { fx: 0.06, fy: 0.05 },
            // sem corFundoFixa: o fundo do selo vem da propria variacao
            corTexto: "#FFFFFF",
            corBorda: "#FFFFFF",
            opacidade: 0.9,
          },
        ],
      },
    };
  },
};

export default modelo;
